import React from 'react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { TrackingRetargetingSettings } from '../components/settings/TrackingRetargetingSettings';

export default function TrackingSettingsPage() {
  return (
    <DashboardLayout>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrackingRetargetingSettings />
      </div>
    </DashboardLayout>
  );
}
